<template>
	<a :href="link.url ? link.url : link" :target="link.target ? link.target : target" class="button">{{ link.title ? link.title : label }}</a>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {
		link: {},
    label: {},
    target: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	destroyed() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.button {
	border: 2px solid $signs-pink;
	color: $signs-pink;
	padding: 10px 20px;
	font-size: 0.85rem;
	max-height: 40px;
	border-radius: 3px;
	text-decoration: none;
	transition: 0.2s ease all;
	font-family: 'Sul Sans', Arial, Helvetica, sans-serif;
	font-weight: bold;
	margin: 0;
	text-transform: uppercase;

	&:hover {
		background: $signs-pink;
		color: white;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/PrimaryButton.vue